import styled from 'styled-components';

import {ContentContainer} from 'components/ui-kit/PageComponents';
import {colors, font} from 'theme';

export const ContentWrapper = styled(ContentContainer)``;

export const Root = styled.div`
    display: flex;
    flex-direction: column;
    gap: 20px;
    width: 100%;
    height: 100%;
`;

export const HeadlineText = styled.div`
    font-size: 24px;
    font-weight: 600;
    color: ${colors.textPrimary};
    font-family: ${font.family.primary};
    font-size: 20px;
    line-height: 30px;
`;

export const SubheadlineText = styled.div`
    font-size: 16px;
    font-weight: 400;
    color: ${colors.textSecondary};
    font-family: ${font.family.primary};
    font-size: 14px;
    line-height: 21px;
    margin-bottom: 20px;
`;

export const FormContainer = styled.div`
    display: flex;
    flex-direction: column;
    gap: 20px;
    width: 100%;
    height: 100%;
`;
export const FormWrapper = styled.div`
    display: flex;
    flex-direction: column;
    gap: 20px;
    width: 100%;
    height: 100%;
`;
export const FormField = styled.div`
    display: flex;
    flex-direction: column;
    gap: 10px;
    width: 100%;
    height: 100%;
`;
export const DatePickerField = styled.div`
    width: 100%;
`;
export const NavigationButtonsContainer = styled.div`
    display: flex;
    justify-content: flex-end;
    gap: 10px;
    width: 100%;
`;

export const ButtonInner = styled.div<{$active: boolean}>`
    display: flex;
    flex-direction: column;
    align-items: flex-start;
    justify-content: center;
    gap: 4px;
    width: 100%;
    height: 100%;
    color: ${(p) => (p.$active ? colors.textSecondary : colors.brandPrimary)};

    > span:first-child {
        font-family: ${font.family.primary};
        font-weight: 600;
        font-size: 14px;
        line-height: 21px;
    }
    > span:last-child {
        font-family: ${font.family.primary};
        font-weight: 400;
        font-size: 12px;
        line-height: 18px;
    }
`;
